import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/')({
  beforeLoad: () => {
    // Until /app/:orgSlug/dashboard exists, send the authenticated user to
    // the works catalog (the highest-traffic /app/* surface).
    throw redirect({ to: '/app/works' });
  },
});
